import React from 'react';
import styles from './Card.module.css';

const Card = ({ value, suit, angle, id }) => {
  const valueAsNumber = parseInt(value);
  const pips = [];

  const createPip = (key) => (
    <div key={key} className={styles.pip}></div>
  );

  if (isNaN(valueAsNumber)) {
    pips.push(createPip(0));
  } else {
    for (let i = 0; i < valueAsNumber; i++) {
      pips.push(createPip(i));
    }
  }

  // Generate dynamic class names based on suit and value
  const getSuitClass = () => {
    const suitMap = {
      'heart': styles.cardHeart,
      'diamond': styles.cardDiamond,
      'spade': styles.cardSpade,
      'club': styles.cardClub
    };
    return suitMap[suit.toLowerCase()] || '';
  };

  const getValueClass = () => {
    if (value === 'A') return styles.cardAce;
    if (value === 'J') return styles.cardJack;
    if (value === 'Q') return styles.cardQueen;
    if (value === 'K') return styles.cardKing;
    return styles[`card${value}`] || '';
  };

  const getValueSuitClass = () => {
    // For face cards, combine value and suit (e.g., cardJackHeart)
    if (['J', 'Q', 'K'].includes(value)) {
      const suitCapitalized = suit.charAt(0).toUpperCase() + suit.slice(1).toLowerCase();
      const valueMap = {
        'J': 'Jack',
        'Q': 'Queen',
        'K': 'King'
      };
      return styles[`card${valueMap[value]}${suitCapitalized}`] || '';
    }
    return '';
  };

  return (
    <div 
      id={id} 
      className={`${styles.card} ${getSuitClass()} ${getValueClass()} ${getValueSuitClass()}`}
      style={{ transform: `rotate(${angle}deg)` }}
    >
      {pips}
      <div className={`${styles.cornerNumber} ${styles.top}`}>{value}</div>
      <div className={`${styles.cornerNumber} ${styles.bottom}`}>{value}</div>
    </div>
  );
};

export default Card;